import React, { useState } from "react";
import AsyncSelect from "react-select/async";
import { toast } from "react-toastify";
import _ from "lodash";
import { api } from "../utils";

export default function ResaleItemTypeahead(props) {
   const [inputValue, setInputValue] = useState("");
   const [loading, setLoading] = useState(false);

   const loadItemOptions = (typedValue, callback) => {
      if (!typedValue || !typedValue.length || typedValue.length < 2) return;

      let payload = { searchString: typedValue };
      setLoading(true);
      api
         .post("Item/ResaleItemTypeahead", payload)
         .then((response) => {
            let list = _.map(response.data, (d) => {
               d.label = d.itemWithDesc;
               d.value = d.item;
               // need all the values for other
               return d;
            });
            callback(list);
         })
         .catch(() => {
            toast.error("There was an error loading item information.");
            callback([]);
         })
         .finally(() => setLoading(false));
   }

   return (
      <AsyncSelect
         id={props.id || ""}
         classNamePrefix='serviceThreadSelect'
         inputValue={inputValue}
         isClearable
         isDisabled={props.disabled}
         isLoading={loading}
         loadOptions={loadItemOptions}
         noOptionsMessage={() => "Start typing to search"}
         onChange={props.onChange}
         onFocus={props.onFocus}
         onInputChange={(e) => setInputValue(e)}
         placeholder={props.placeholder || "Type the resale item you are looking for"}
         value={props.value}
      />
   );
} 